import { render, staticRenderFns } from "./StudentActivityTableReadonlyTextCell.vue?vue&type=template&id=1b3d9aae&scoped=true&"
import script from "./StudentActivityTableReadonlyTextCell.vue?vue&type=script&lang=ts&"
export * from "./StudentActivityTableReadonlyTextCell.vue?vue&type=script&lang=ts&"
import style0 from "./StudentActivityTableReadonlyTextCell.vue?vue&type=style&index=0&id=1b3d9aae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d9aae",
  null
  
)

export default component.exports